/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
import {
  getSelectedState,
  Grid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Textarea,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@repo/ui";
import { showToast } from "utils/helper";
import { useGetCashCenters, useGetInRouteTeam } from "utils/apis/lookups.api";
import {
  useCreateHandoverRequest,
  useGetHandoverJobs,
} from "utils/apis/handover.api";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { formatDate } from "date-fns";
import { PREV_5_DAY_DATE } from "utils/constant";

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

const handoverReasons = [
  {
    value: "Route Management",
    label: "Route Management",
  },
  {
    value: "Accident",
    label: "Accident",
  },
  {
    value: "Theft",
    label: "Theft",
  },
];

function CreateHandoverRequest() {
  const currentDate = new Date();

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [dataState2, setDataState2] = useState<any>(initialDataState);
  const CONSIGNMENT_DATA_ITEM_KEY = "id";
  const DATA_ITEM_KEY = "id";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);
  const consignmentIdGetter = getter(CONSIGNMENT_DATA_ITEM_KEY);
  const [operationDate, setOperationDate] = useState(currentDate);
  const [receiverOperationDate, setReceiverOperationDate] =
    useState(currentDate);
  const [ddlDonorCashCenters, setDdlDonorCashCenters] = useState("");
  const [ddlReceivingCashCenters, setDdlReceivingCashCenters] = useState("");
  const [ddlDonarRoute, setDdlDonarRoute] = useState("");
  const [ddlReceiversRoute, setDdlReceiversRoute] = useState("");
  const [ddlHandoverReasons, setDdlHandoverReasons] = useState("");
  const [remarks, setRemarks] = useState("");

  const [services, setServices] = useState([]);

  const [isConfirmHandover, setIsConfirmHandover] = useState(false);
  const [btnUpdateText, setBtnUpdateText] = useState("Confirm Handover");
  const [selectedState, setSelectedState] = useState<any>({});
  const [selectedConsignmentState, setSelectedConsignmentState] = useState<any>(
    {},
  );
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [selectedConsignmentRequests, setSelectedConsignmentRequests] =
    useState([]);

  const { data: cashCenters } = useGetCashCenters();
  const { data: inRouteTeams } = useGetInRouteTeam({
    cashCenterId: ddlDonorCashCenters,
    shift: "morning",
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { data: receivingRouteTeams } = useGetInRouteTeam({
    cashCenterId: ddlReceivingCashCenters,
    shift: "morning",
    operationDate: formatDate(
      receiverOperationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { data: routeServicesData, isFetching: loadingRequests } =
    useGetHandoverJobs({
      cashCenterId: ddlDonorCashCenters,
      shift: "morning",
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlDonarRoute,
    });

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs?.map((req: any) => {
      const service: any = services?.find(
        (srv: any) => idGetter(srv) === req.itemKey,
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });

    setSelectedRequests(
      requestIds?.flatMap((item: any) =>
        item.containers?.map((container: any) => ({
          ...container,
          id: crypto.randomUUID(),
          requestId: item.requestId,
        })),
      ),
    );
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedReq = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedReq.map((req: any) => {
      const service: any = services.find(
        (srv: any) => idGetter(srv) === req.itemKey,
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });
    setSelectedRequests(
      requestIds.flatMap((item: any) =>
        item.containers.map((container: any) => ({
          ...container,
          id: crypto.randomUUID(),
          requestId: item.requestId,
        })),
      ),
    );
  };

  const onConsignmentSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedConsignmentState,
      dataItemKey: CONSIGNMENT_DATA_ITEM_KEY,
    });

    setSelectedConsignmentState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req: any) => {
      const service: any = selectedRequests.find(
        (srv: any) => consignmentIdGetter(srv) === req.itemKey,
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });

    setSelectedConsignmentRequests(requestIds);
  };

  const onConsignmentHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[consignmentIdGetter(item)] = checked;
    });
    setSelectedConsignmentState(newSelectedState);
    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedReq = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedReq.map((req: any) => {
      const service: any = selectedRequests.find(
        (srv: any) => consignmentIdGetter(srv) === req.itemKey,
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });
    setSelectedConsignmentRequests(requestIds);
  };

  const onReceiverRouteChanged = (value: string) => {
    if (!value) {
      setDdlReceiversRoute("");
      return;
    }

    if (ddlDonarRoute) {
      if (ddlDonarRoute === value) {
        setDdlReceiversRoute("");
        showToast("error", "Donar & receiver can not be same.");
        return;
      }
    }

    setDdlReceiversRoute(value);
  };

  const handleIsConfirmModal = (isOpen: boolean) => {
    setIsConfirmHandover(isOpen);
    if (!isOpen) {
      setSelectedConsignmentRequests([]);
    }
  };

  const onConfirmHandoverConsignments = () => {
    if (!ddlDonorCashCenters) {
      showToast("error", "Please select cash center");
      return;
    }

    if (!ddlDonarRoute) {
      showToast("error", "Please select donar route");
      return;
    }

    handleIsConfirmModal(true);

    setSelectedRequests((prevServices: any) => {
      return prevServices?.map((req: any) => {
        const service: any = services.find(
          (srv: any) => idGetter(srv) === req.itemKey,
        );
        if (service) {
          return { ...service, selected: true };
        }

        return req;
      });
    });
  };

  const {
    mutate: createHandoverRequest,
    isSuccess: createSuccess,
    isError: createError,
  } = useCreateHandoverRequest();

  const onHandoverRequestCreated = () => {
    if (!ddlReceivingCashCenters) {
      showToast("error", "Please donar team leader.");
      return;
    }

    if (!ddlReceiversRoute) {
      showToast("error", "Please receiving team leader.");
      return;
    }

    if (!ddlHandoverReasons) {
      showToast("error", "Please handover reason.");
      return;
    }

    const grouped = selectedConsignmentRequests.reduce(
      (acc: any, item: any) => {
        if (!acc[item.requestId]) {
          acc[item.requestId] = [];
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { requestId, id, selected, ...container } = item;
        acc[item.requestId].push(container);

        return acc;
      },
      {},
    );

    const updatedMainArray = services
      // remove objects not in flatContainers
      .filter((item: any) => grouped[item.requestId])
      // update containers
      .map((item: any) => ({
        ...item,
        containers: grouped[item.requestId],
      }));

    const handoverDto = {
      donarCashCenterId: ddlDonorCashCenters,
      receiverCashCenterId: ddlReceivingCashCenters,
      donarRouteNo: ddlDonarRoute,
      receiverRouteNo: ddlReceiversRoute,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      receiverOperationDate: formatDate(
        receiverOperationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      shift: "morning",
      handoverReason: ddlHandoverReasons,
      orders: updatedMainArray,
    };

    setBtnUpdateText("Confirming.....");
    createHandoverRequest(handoverDto);
  };

  useEffect(() => {
    if (routeServicesData?.length) {
      const servicesList = routeServicesData.map((r: any) => ({
        ...r,
        id: `${r?.jobNo}_${r?.orderId}`,
        selected: false,
      }));
      setServices(servicesList);
    } else {
      setServices([]);
    }
  }, [routeServicesData]);

  useEffect(() => {
    if (ddlDonarRoute) {
      setSelectedRequests([]);
      setSelectedState({});
    }
  }, [ddlDonarRoute]);

  useEffect(() => {
    if (createSuccess) {
      setDdlDonorCashCenters("");
      setDdlDonarRoute("");
      setDdlReceiversRoute("");
      setDdlHandoverReasons("");
      setOperationDate(currentDate);
      setRemarks("");
      setBtnUpdateText("Confirm Handover");
      setServices([]);
      setSelectedConsignmentRequests([]);
    }
    if (createError) {
      setBtnUpdateText("Confirm Handover");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createSuccess, createError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/consignments-handover">Consignments Handover</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="grid grid-cols-3 gap-4 mb-3">
            <div>
              <label className="font-medium text-sm">Operations Date</label>
              <DatePicker
                className="w-100"
                selectedDate={operationDate}
                onSelectDate={(e: Date) => {
                  setOperationDate(e);
                }}
                disabled={(date) => date < PREV_5_DAY_DATE}
              />
            </div>

            <div>
              <label className="font-medium text-sm">Donor Cash Center</label>
              <Combobox
                data={cashCenters?.map((m: any) => ({
                  value: m.cashCenterId,
                  label: m.name,
                }))}
                value={ddlDonorCashCenters}
                placeholder="Select Donor Cash Center"
                setValue={setDdlDonorCashCenters}
              />
            </div>
            <div>
              <label className="font-medium text-sm">Donar Route</label>
              <Combobox
                data={inRouteTeams?.map((m: any) => ({
                  value: m.routeNo,
                  label: `${m.routeNo} (${m.description})`,
                }))}
                value={ddlDonarRoute}
                placeholder="Select Donar Route"
                setValue={setDdlDonarRoute}
              />
            </div>
          </div>
          <Button
            className="ml-auto flex mt-5"
            variant="secondary"
            disabled={!selectedRequests?.length}
            onClick={onConfirmHandoverConsignments}
          >
            Consignments Handover
          </Button>
          {loadingRequests ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : null}
          <Grid
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            data={process(
              services?.map((req: any) => ({
                ...req,
                [SELECTED_FIELD]: selectedState[idGetter(req)],
              })) || [],
              {
                ...dataState,
                skip: 0,
              },
            )}
            {...dataState}
            onDataStateChange={(e: any) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple",
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
          >
            <Column
              field={SELECTED_FIELD}
              filterable={false}
              width="40px"
              headerSelectionValue={
                services?.findIndex(
                  (item: any) => !selectedState[idGetter(item)],
                ) === -1
              }
            />
            <Column
              field="jobNo"
              title="Job No"
              className="text-center"
              width="90"
            />
            <Column field="orderId" title="Order Id" width="160" />
            <Column field="customer" title="Customer" width="240" />
            <Column
              field="sourceLocationBarcode"
              title="Source"
              width="340"
              cell={({ dataItem }) => (
                <td>
                  {dataItem?.sourceLocationBarcode}-{dataItem?.sourceLocationId}
                </td>
              )}
            />
            <Column
              field="locationBarcode"
              title="Onward"
              width="340"
              cell={({ dataItem }) => (
                <td>
                  {dataItem?.locationBarcode}-{dataItem?.locationId}
                </td>
              )}
            />

            <Column
              field="serviceType"
              title="Service Type"
              className="text-center"
              width="140"
            />
            <Column
              field="jobType"
              title="Job Type"
              className="text-center"
              width="140"
            />
            <Column
              field="status"
              title="Status"
              className="text-center"
              width="140"
            />
            <Column field="remarks" title="Remarks" />
          </Grid>

          <Dialog open={isConfirmHandover} onOpenChange={handleIsConfirmModal}>
            <DialogContent className="max-w-[1050px]">
              <DialogHeader>
                <DialogTitle>Confirm Handover Consignments</DialogTitle>
              </DialogHeader>
              <DialogDescription className="max-h-[70vh] overflow-auto">
                <div className="grid grid-cols-3 gap-4 px-1">
                  <div>
                    <label className="font-medium text-sm">
                      Receiver Operations Date
                    </label>
                    <DatePicker
                      className="w-100"
                      selectedDate={receiverOperationDate}
                      onSelectDate={(e: Date) => {
                        setReceiverOperationDate(e);
                      }}
                      disabled={(date) => date < PREV_5_DAY_DATE}
                    />
                  </div>
                  <div>
                    <label className="font-medium text-sm">
                      Handover Reason
                    </label>
                    <Combobox
                      data={handoverReasons}
                      value={ddlHandoverReasons}
                      placeholder="Select Handover Reason"
                      setValue={setDdlHandoverReasons}
                    />
                  </div>

                  <div>
                    <label className="font-medium text-sm">
                      Receiving Cash Center
                    </label>
                    <Combobox
                      data={cashCenters?.map((m: any) => ({
                        value: m.cashCenterId,
                        label: m.name,
                      }))}
                      value={ddlReceivingCashCenters}
                      placeholder="Select Receiving Cash Center"
                      setValue={setDdlReceivingCashCenters}
                    />
                  </div>

                  <div>
                    <label className="font-medium text-sm">
                      Receiving Route
                    </label>

                    <Combobox
                      data={receivingRouteTeams?.map((m: any) => ({
                        value: m.routeNo,
                        label: `${m.routeNo} (${m.description})`,
                      }))}
                      value={ddlReceiversRoute}
                      placeholder="Select Receiving Route"
                      setValue={onReceiverRouteChanged}
                    />
                  </div>

                  <div className="col-span-3">
                    <label className="font-medium text-sm">Remarks</label>
                    <Textarea
                      className="w-full resize-none"
                      value={remarks}
                      onChange={(e) => {
                        setRemarks(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <Button
                  className="ml-auto flex my-3 w-[180px]"
                  variant="secondary"
                  onClick={onHandoverRequestCreated}
                  disabled={
                    !ddlReceiversRoute ||
                    !ddlReceivingCashCenters ||
                    !ddlHandoverReasons ||
                    !selectedConsignmentRequests?.length
                  }
                >
                  {btnUpdateText}
                </Button>
                <TooltipProvider>
                  <Grid
                    dataItemKey={CONSIGNMENT_DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    data={process(
                      selectedRequests?.map((req: any) => ({
                        ...req,
                        [SELECTED_FIELD]:
                          selectedConsignmentState[consignmentIdGetter(req)],
                      })) || [],
                      {
                        ...dataState2,
                        skip: 0,
                      },
                    )}
                    {...dataState2}
                    onDataStateChange={(e: any) => {
                      setDataState2(e.dataState2);
                    }}
                    filterable
                    sortable
                    selectable={{
                      enabled: true,
                      drag: true,
                      cell: false,
                      mode: "multiple",
                    }}
                    onSelectionChange={onConsignmentSelectionChange}
                    onHeaderSelectionChange={onConsignmentHeaderSelectionChange}
                  >
                    <Column
                      field={SELECTED_FIELD}
                      filterable={false}
                      width="40px"
                      headerSelectionValue={
                        selectedRequests?.findIndex(
                          (item: any) =>
                            !selectedConsignmentState[
                              consignmentIdGetter(item)
                            ],
                        ) === -1
                      }
                    />
                    <Column field="consignmentType" title="Consignment Type" />
                    <Column field="containerType" title="Bag Type" />
                    <Column field="currency" title="Currency" />
                    <Column field="details" title="Denomination" />
                    <Column field="declaredValue" title="Value" />
                    <Column field="count" title="Count" width="70px" />
                    <Column
                      field="sealNo"
                      title="Seal No."
                      cell={({ dataItem }) => (
                        <td>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <p className="text-ellipsis overflow-hidden">
                                {dataItem?.sealNo}
                              </p>
                            </TooltipTrigger>
                            <TooltipContent>{dataItem?.sealNo}</TooltipContent>
                          </Tooltip>
                        </td>
                      )}
                    />
                    <Column field="remarks" title="Remarks" />
                  </Grid>
                </TooltipProvider>
              </DialogDescription>
            </DialogContent>
          </Dialog>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default CreateHandoverRequest;
